// src/routes/PaymentVerificationRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

import PaymentVerificationPage from '../pages/payments/PaymentVerificationPage';

const PaymentVerificationRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PermissionRoute requiredPermission="verify_payment_records">
            <PaymentVerificationPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default PaymentVerificationRoutes;
